import { put, takeEvery } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";

import { ApiGatewayApi } from "api";
import { CredentialsProvider } from "auth/modules/sagas/CredentialsProvider";

import { DELETE_CMS_TOKEN, DeleteCMSTokenAction, deleteCMSTokenEnd } from "../actions/DeleteCMSToken";

export function* deleteCMSToken(action: DeleteCMSTokenAction) {
    const { appId, credentials, tokenId } = action.payload;

    try {
        const api = new ApiGatewayApi(new CredentialsProvider(credentials));

        yield put(loading(true, action));
        yield api.deleteCMSToken(tokenId);
        yield put(deleteCMSTokenEnd(appId, undefined, tokenId));
        // TODO: should probably fetch the updated token list here
        yield put(addNotification("CMSToken successfully deleted"));
    } catch (e) {
        yield put(deleteCMSTokenEnd(appId, e, undefined));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchDeleteCMSToken() {
    yield takeEvery(DELETE_CMS_TOKEN, deleteCMSToken);
}
